import type { JSX } from 'react'

export const VerticalVideoIcon = (): JSX.Element => (
  <use href='#verticalVideoIcon' height='100%' width='100%' />
)
